<template>
  <div></div>
</template>

<script>
export default {
  name: 'webscoket',
  data() {
    return {
      websocketObj: null,
      webScoketCloseStatus: true,
      webScoketBaseUrl: '',
      reconnectionIndex: 0,
      timeObj: null
    }
  },
  methods: {
    // 初始化webscoket
    initWebScocket() {
      let that = this
      that.websocketObj = null
      // 判断当前浏览器是否支持WebSocket
      if ('WebSocket' in window) {
        // that.websocketObj = new WebSocket('ws://139.9.70.1:8788' + that.webscoketUrl + that.$store.state.User.userInfo.userId)
        that.websocketObj = new WebSocket(`${that.webScoketBaseUrl}${that.webscoketUrl}${that.$store.getters.userId}`)
        // console.log('that.websocketObj', that.websocketObj)
      } else {
        alert('Not support websocket')
      }

      // 连接发生错误的回调方法
      that.websocketObj.onerror = function () {
        setTimeout(() => {
          // console.log('webscoket 连接发生错误 继续尝试重新连接')
          that.initWebScocket() // 重新连接 webScoket
        }, 3000)
        // setMessageInnerHTML('error')
      }

      // 连接成功建立的回调方法
      that.websocketObj.onopen = function (event) {
        that.timeObj = setInterval(() => {
          // console.log('webscoket心跳唤醒')
          // that.websocketObj.send('hello')
        }, 30000)
        // console.log('打开webscoket')
        // setMessageInnerHTML('open')
      }

      // 接收到消息的回调方法
      that.websocketObj.onmessage = function (event) {
        // console.log('event接收到消息的回调方法', event)
        if (event.data != 'success') {
          that.$emit('onMessage', JSON.parse(event.data))
        }
        // setMessageInnerHTML(event.data)
      }

      // 连接关闭的回调方法
      that.websocketObj.onclose = function () {
        // console.log('关闭webscoket')
        clearTimeout(that.timeObj)
        if (that.$store.getters.userId !== undefined && that.webScoketCloseStatus && that.reconnectionIndex < 4) {
          // console.log('webscoket 关闭后 重新连接 webscoket')
          that.reconnectionIndex = that.reconnectionIndex + 1
          that.websocketObj.close()
          that.initWebScocket() // 重新连接 webScoket
        }
        // setMessageInnerHTML('close')
      }

      // 监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
      // that.websocketObj.onbeforeunload = function () {
      //   that.websocketObj.close()
      // }
    },
    beforeunloadHandler() {
      clearTimeout(this.timeObj)
      this.websocketObj.close()
    }
  },
  mounted() {
    let url = process.env.VUE_APP_BASE_URL.split('//')[1]

    // this.webScoketBaseUrl = `ws://${url}`
    // console.log('环境process.env.NODE_ENV', process.env.NODE_ENV)
    if (process.env.NODE_ENV == 'production') {
      // url = '119.3.212.66:9091'
      this.webScoketBaseUrl = `wss://${url}`
    } else {
      // url = '192.168.0.76:9091'
      this.webScoketBaseUrl = `ws://${url}`
    }
    window.addEventListener('beforeunload', (e) => this.beforeunloadHandler(e))
    this.initWebScocket()
  },
  props: {
    webscoketUrl: {
      required: true,
      type: String
    }
  },
  beforeDestroy() {
    this.webScoketCloseStatus = false
    this.websocketObj.close() // 关闭 webscoket
  }
}
</script>

<style scoped lang="less"></style>
